import { render, staticRenderFns } from "./expendables.vue?vue&type=template&id=0a6df143&scoped=true&"
import script from "./expendables.vue?vue&type=script&lang=js&"
export * from "./expendables.vue?vue&type=script&lang=js&"
import style0 from "./expendables.vue?vue&type=style&index=0&id=0a6df143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6df143",
  null
  
)

export default component.exports